import { asyncLoadScript, waitScriptLoaded } from "integrations/helpers";
import { Logger } from "shared/mechanics/logging";
import { IPlugin } from "shared/mechanics/plugin";

declare global {
	interface Window { YooMoneyCheckoutWidget: any; }
}

export interface IYouKassaPaymentFormsApi {
	createPaymentForm(elementId: string, confirmationToken: string): void;
}


export class YouKassaPaymentPlugin implements IPlugin {
	name: string = "YouKassa Payments";

	init(): void {
		asyncLoadScript('https://yookassa.ru/checkout-widget/v1/checkout-widget.js');
	}

	async createFormsApi(): Promise<IYouKassaPaymentFormsApi> {
		await waitScriptLoaded(() => window.YooMoneyCheckoutWidget, 100);

		return new YouKassaPaymentFormsApi();
	}
}

class YouKassaPaymentFormsApi implements IYouKassaPaymentFormsApi {
	createPaymentForm(elementId: string, confirmationToken: string): void {
		const checkout = new window.YooMoneyCheckoutWidget({
			confirmation_token: confirmationToken,
			return_url: `${window.location.origin}/subscription/complete`,
			error_callback: function (error: any) {
				Logger.logException('Ошибка при формировании платежа', error);
			}
		});

		checkout.render(elementId);
	}
}